import { Backdrop, Button, Fade, IconButton, Modal } from '@material-ui/core';
import { InfoAwesomeIcon } from 'app/shared/icons';
import CloseIcon from '@material-ui/icons/Close';
import { Markup } from 'interweave';
import React from 'react';
import '../modal-style.scss';
import { IRootState } from 'app/shared/reducers';
import { useSelector } from 'react-redux';

export interface IModalInfoProps {
    modal: boolean;
    message: string[];
    txtValidButton?: string;
    txtCancelButton?: string;
    setModal(data: boolean): void;
    handleOk?(): void;
    handleCancel?(): void;
    className?: string;
    closeButton?: boolean;
}
const ModalInfo = (props: IModalInfoProps) => {
    const {
        modal,
        message,
        txtValidButton,
        txtCancelButton,
        setModal,
        handleOk,
        handleCancel,
        className,
        closeButton
    } = props;

    const { isMobile } = useSelector((state: IRootState) => state.cms);

    const handleOkClick = () => {
        setModal(false);
        if (handleOk) {
            handleOk();
        }
    }

    const handleCancelClick = () => {
        setModal(false);
        if (handleCancel) {
            handleCancel();
        }
    }

    const handleCloseClick = () => {
        setModal(false);
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={"modal-container" + (!isMobile ? " desktop-modal" : "")}
            open={modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={modal}>
                <div className="paper-info">
                    {closeButton && <IconButton className="btn-close" onClick={handleCloseClick}>
                        <CloseIcon htmlColor="var(--primary-text)" />
                    </IconButton>
                    }
                    <InfoAwesomeIcon />
                    <div className={"paper-info-text " + (className ? className : "")}>
                        {
                            message.map((msg, index) => {
                                return (
                                    <div key={index}>
                                        <Markup noWrap content={msg} />
                                    </div>
                                );
                            })}
                    </div>
                    <br />
                    <div className="desktop-popup-btn">
                        <Button variant="contained"
                            className="btn"
                            style={{ margin: '0.5rem' }}
                            onClick={handleOkClick}
                            disableElevation>
                            {txtValidButton ? txtValidButton : 'Compris'}
                        </Button>
                        {txtCancelButton && <Button variant="contained"
                            className="btn"
                            style={{ margin: '0.5rem' }}
                            onClick={handleCancelClick}
                            disableElevation>
                            {txtCancelButton ? txtCancelButton : 'Annuler'}
                        </Button>}
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}


export default ModalInfo;
